const handler = ( $ ) => {
	if ( $( 'body' ).hasClass( 'page-template-page-get-in-touch' ) ) {
		const $mapEl = $( '#google-map' );
		if ( $mapEl.length === 0 ) {
			console.warn( 'Map element #google-map not found.' );
			return;
		}
		if ( $mapEl.hasClass( 'map-initializated' ) ) {
			$mapEl.html( '' );
		}
		$mapEl.addClass( 'map-initializated' );

		const isMobile = window.innerWidth <= 768;
		const zoom = isMobile ? 14 : $mapEl.data( 'zoom' );
		// Create gerenic map.
		const mapArgs = {
			zoom: zoom || 16,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			disableDefaultUI: true,
			zoomControl: false,
			mapTypeControl: false,
			scaleControl: false,
			streetViewControl: false,
			rotateControl: false,
			fullscreenControl: false,
			clickableIcons: false,
			styles: window.googleMapsDarkStyles,
		};

		const map = new google.maps.Map( $mapEl[ 0 ], mapArgs );

		const initMarker = function ( $marker, map ) {
			const lat = $marker.data( 'lat' );
			const lng = $marker.data( 'lng' );
			const latLng = {
				lat: parseFloat( lat ),
				lng: parseFloat( lng ),
			};

			const marker = new google.maps.Marker( {
				position: latLng,
				map: map,
				icon: {
					url:
						window.location.origin +
						'/wp-content/themes/bilberrry/assets/images/marker.png',
					scaledSize: new google.maps.Size( 24, 49 ),
					origin: new google.maps.Point( 0, 0 ),
					anchor: new google.maps.Point( 24, 49 ),
				},
			} );

			map.markers.push( marker );
		};

		map.markers = [];
		initMarker( $mapEl, map );

		// Create map boundaries from all map markers.
		const bounds = new google.maps.LatLngBounds();
		map.markers.forEach( function ( marker ) {
			bounds.extend( {
				lat: marker.position.lat(),
				lng: marker.position.lng(),
			} );
		} );

		// Case: Single marker.
		if ( map.markers.length == 1 ) {
			map.setCenter( bounds.getCenter() );
			// Case: Multiple markers.
		} else {
			map.fitBounds( bounds );
		}
	}
};

export default ( ( $ ) => $( handler ) )( jQuery );
